import { BiListUl, BiGridAlt } from "react-icons/bi";

const ViewToggle = ({ view, onChange }) => (
    <div className="flex bg-gray-100 p-1 rounded-lg border border-gray-200">
        <button
            onClick={() => onChange('list')}
            className={`p-1.5 rounded-md transition-all ${view === 'list' ? "bg-white shadow-sm text-custom_blue" : "text-gray-400 hover:text-gray-600"}`}
        >
            <BiListUl size={20} />
        </button>
        <button
            onClick={() => onChange('grid')}
            className={`p-1.5 rounded-md transition-all ${view === 'grid' ? "bg-white shadow-sm text-custom_blue" : "text-gray-400 hover:text-gray-600"}`}
        >
            <BiGridAlt size={20} />
        </button>
    </div>
);

export default ViewToggle;